import { useState } from 'react';

/**
 * Tracks whether a nearby chakra-react-select menu is open, so a FieldToolTip
 * can flip to `placement="top"` and avoid overlapping the popup.
 *
 * `onMenuClose` passes straight through DropDown's own prop spread and is
 * always reliable. There is no equivalent open hook available without
 * touching DropDown itself, so `onMouseDown` (click-to-open is the dominant
 * interaction) is used as the open signal instead.
 */
export const useDropdownMenuTooltip = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return {
        tooltipPlacement: isMenuOpen ? 'top' : undefined,
        onMouseDown: () => setIsMenuOpen(true),
        onMenuClose: () => setIsMenuOpen(false),
    };
};
